import React, { useEffect, useState } from 'react';
import './DayView.scss';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { userSelector } from '../../../redux/slices/userSlice';
import { TargetType } from '../../../types/TargetType';
import { updateGroupTarget, updateTarget } from '../../../database/update';
import { displayToast, getOtherUserId } from '../../../helpers/app-helpers';
import { appDataActions, appDataSelector } from '../../../redux/slices/appDataSlice';
import { BattleType } from '../../../types/BattleType';
import { DayType } from '../../../types/DayType';
import { ContestantType } from '../../../types/ContestantType';
import BattleCard from './battle-card/BattleCard';
import { convertBooleanToString } from '../../../database/database-utils';
import Spinner from '../../../ui-components/spinner/Spinner';
import { UserType } from '../../../types/UserType';
import { getUser } from '../../../database/read';

const DayView: React.FC<{
  otherContestant: ContestantType;
  otherUser: UserType;
  battle: BattleType;
  setActiveView: (event: 'CALENDER' | 'DAY') => void;
}> = ({
  otherContestant,
  otherUser,
  battle,
  setActiveView
}) => {

    const dispatch = useAppDispatch();
    const user = useAppSelector(userSelector);
    const appData = useAppSelector(appDataSelector);
    const userContestant = battle.isGroupBattle
      ? battle.contestants.find(e => e.id === user.id) as ContestantType
      : battle.challenger.id === user.id ? battle.challenger : battle.opponent

    const [targets, setTargets] = useState<TargetType[]>([]);
    const [day, setDay] = useState<any>();
    const [isUpdatingTarget, setIsUpdatingTarget] = useState(false);
    const [otherUsers, setOtherUsers] = useState<UserType[]>([]);

    useEffect(() => {
      getAndSetOtherUsers();
      dispatch(appDataActions.setBackgroundClass('app__background app__background--table'));
      return () => { dispatch(appDataActions.setBackgroundClass('app__background')) };
    }, [])

    useEffect(() => {
      const day = battle.days.filter((day: DayType) => day.dayKey === appData.currentDayKey)[0];
      setDay(day);
    }, [battle])

    useEffect(() => {
      if (day) {
        sortAndSetTargets();
      }
    }, [day])

    const getAndSetOtherUsers = async () => {
      const otherUsers: any[] = [];
      for (const id of battle.userIds) {
        if (id !== user.id) {
          otherUsers.push(await getUser(id));
        }
      }
      setOtherUsers(otherUsers);
    }

    const sortAndSetTargets = () => {
      const targets: TargetType[] = [...day.targets];
      const sortedTargets = sortTargets(targets);

      setTargets(sortedTargets);
    }

    const sortTargets = (targets: TargetType[]) => {
      const sortedTargets = targets.sort((a: any, b: any) => {
        let aNumber = a.targetKey.match(/\d/g);
        aNumber = +aNumber.join("");
        let bNumber = b.targetKey.match(/\d/g);
        bNumber = +bNumber.join("");
        return bNumber - aNumber;
      });
      return sortedTargets;
    }

    const onChange = async (input: boolean, target: TargetType, hideNumberCheck: boolean, photo: string = '') => {
      let stillUpdating = true;
      setTimeout(() => {
        if (stillUpdating) setIsUpdatingTarget(true);
      }, 500);
      let success = false;
      if (battle.isGroupBattle) {
        success = await updateGroupTarget(battle.id, day.dayKey, target.targetKey, convertBooleanToString(input), user.id, battle, target, photo);
      } else {
        success = await updateTarget(battle.id, day.dayKey, target.targetKey, convertBooleanToString(input), user.id, otherUser.id, hideNumberCheck, battle, target, photo);
      }
      if (!success) displayToast(dispatch, 'Failed to update target. Please try again.')
      stillUpdating = false;
      setIsUpdatingTarget(false);
    }

    return (
      <div className="day-view">
        {isUpdatingTarget && (
          <>
            <div className="full-screen-mask" />
            <div className="day-view__spinner">
              <Spinner />
            </div>
          </>
        )}

        {/* <div className="day-view__back-card" onClick={() => setActiveView("DAY")}>Back</div> */}

        {battle.isGroupBattle && (
          <div style={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            top: 0,
            width: "100vw"
          }}>
            {battle.contestants.map((contestant => {
              if (contestant.id !== user.id) {
                return (
                  <BattleCard
                    key={contestant.id}
                    contestant={contestant}
                    cardUser={otherUsers.find(e => e.id === contestant.id) as UserType}
                    targets={targets}
                    day={day}
                    battle={battle}
                    onChange={onChange}
                  />
                )
              }
            }))}
          </div>
        )}

        {!battle.isGroupBattle && (
          <BattleCard
            contestant={otherContestant}
            cardUser={otherUser}
            targets={targets}
            day={day}
            battle={battle}
            onChange={onChange}
          />
        )}

        <BattleCard
          contestant={userContestant}
          cardUser={user}
          targets={targets}
          day={day}
          battle={battle}
          onChange={onChange}
        />

      </div>
    )
  }

export default DayView;